
  <section class="header__title">
    <p [class]="classTitle" [innerHTML]="title"></p>
    <p class="subtitle" [innerHTML]="subTitle"></p>
  </section>